import { Component, PLATFORM_ID, OnInit, inject } from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";

import {
  Seo,
  Push,
  CheckForUpdate,
  LogUpdate,
  PromptUpdate,
} from "./core/services";

import { environment } from "../environments/environment";
import { NavigationEnd, Router } from "@angular/router";

declare const ga: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.sass"],
})
export class AppComponent implements OnInit {
  private checkForUpdate = inject(CheckForUpdate);
  private logUpdate = inject(LogUpdate);
  private promptUpdate = inject(PromptUpdate);
  private seo = inject(Seo);
  private push = inject(Push);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private doc = inject(DOCUMENT);

  private title = "itera-front";

  private now = new Date();
  routerSubscription;

  constructor() {
    this.routerSubscription = this.router.events.subscribe((event) => {
      // Send page to google analytics on page change.
      if (event instanceof NavigationEnd && typeof ga !== "undefined") {
        ga("send", "pageview", event.urlAfterRedirects.split("?")[0]);
      }
    });

    this.seo.setDescription(environment.description);
  }

  ngOnInit() {
    // ...
  }

  scroll(el: Element) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
